<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交
          </van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <div style="padding-left: 16px">
        <van-field v-model="inputForm.regCode" label="销售业务信息登记单编号" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.sellerName" label="卖方公司名称" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.buyerName" label="客商名称" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.goodsName" label="商品名称" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.createByName" label="制单人" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.createDate" label="制单日期" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
      </div>
      <van-collapse-item title="车辆信息" name="1">
        <b-table class="bgc-dark" small head-variant="dark" responsive bordered
                 :items="inputForm.cars" :fields="fields">
          <template v-slot:head()="scope">
            <div class="text-nowrap" :style="{textAlign:'center'}">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
            >
          </template>
        </b-table>
      </van-collapse-item>
      <van-collapse-item title="发货信息" name="2">
        <div style=" margin-bottom: 10px; margin-top: 10px; padding-left: 16px">
          <p style="display: block; color: #4caedc" @click="viewDetail()">查看销售信息明细</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="销售业务信息" name="3" v-if="inputForm.type === '1'">
        <div style=" margin-bottom: 10px; margin-top: 10px; padding-left: 16px">
          <p style="display: block; color: #4caedc" @click="viewDetail2()">查看销售业务信息明细</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="销售费用" name="3" v-if="inputForm.type === '2'">
        <b-table class="bgc-dark" small head-variant="dark" responsive bordered
                 :items="inputForm.amounts" :fields="fields2" foot-clone>
          <template v-slot:head()="scope">
            <div class="text-nowrap" :style="{textAlign:'center'}">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(amount)="data">
            {{ Number(data.item.amount).toFixed(2) }}
          </template>

          <template v-slot:cell(remarks)="data">
            <div style="color: #4caedc" @click="showDetail(data.item.remarks)">{{ data.item.remarks }}</div>
          </template>

          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
            >
          </template>
          <template v-slot:foot()="scope">
            <div class="text-nowrap" :style="{textAlign:'center'}"></div>
          </template>
          <template v-slot:foot(index)="data">
            <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">小计</div>
          </template>
          <template v-slot:foot(amount)="data">
            <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(inputForm.amounts, 'amount') }}</div>
          </template>
        </b-table>
        <van-field v-model="inputForm.remarks" label="备注" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
      </van-collapse-item>
      <van-collapse-item title="损耗信息" name="4" v-if="inputForm.type === '1'">
        <van-field v-model="inputForm.num" label="数量（筐）" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.totalWeightExcludePack" label="不含筐总重（斤）" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.remarks" label="备注" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
      </van-collapse-item>

    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "../../../../../components/processRecord/processRecord.vue";
import TaskService from "../../../../../api/flowable/TaskService";
import ProcessService from "../../../../../api/flowable/ProcessService";
import QueryInfoService from "@/api/system/queryInfoService";
import Decimal from "decimal.js";

export default {
  name: "ItsSalesInner",
  data() {
    return {
      activeNames: ['1', '2', '3', '4'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: '',
      inputForm: {
        attachList: [],
        isDoTask: false,
        isLastTask: false,
      },
      flowTable: 'its_sales_depart',
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'carNo', label: '境内运输车牌号', width: '120px'},
        {key: 'address', label: '收货地点', width: '150px'},
        {key: 'departureDate', label: '发车日期', width: '150px'},
        {key: 'arrivalDate', label: '到达日期', width: '150px'},
      ],
      fields2: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'itemName', label: '项目', width: '120px'},
        {key: 'amount', label: '金额（元）', width: '150px'},
        {key: 'remarks', label: '备注', width: '150px'},
      ],
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/its/sales/itsSalesInner/queryById').then(({data}) => {
        this.inputForm = data
        if(this.inputForm.type === '1') {
          this.fields = [
            {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
            {key: 'carNo', label: '境内运输车牌号', width: '120px'},
            {key: 'address', label: '收货地点', width: '150px'},
            {key: 'departureDate', label: '发车日期', width: '150px'},
            {key: 'arrivalDate', label: '到达日期', width: '150px'},
          ]
        } else {
          this.fields = [
            {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
            {key: 'carNo', label: '境内运输车牌号', width: '120px'},
            {key: 'packAddressName', label: '冷库', width: '120px'},
            {key: 'address', label: '收货地点', width: '150px'},
            {key: 'departureDate', label: '发车日期', width: '150px'},
            {key: 'arrivalDate', label: '到达日期', width: '150px'},
          ]
        }
        this.updateDictNames(this.inputForm.cars,{its_base_variety_level:'varietyLevel'})
        this.updateDictNames(this.inputForm.details,{sales_method:'type', price_mode: 'model', sales_pay_type: 'payType'})
        this.inputForm.createDate = data.createDate.slice(0, 10)
      }).catch(e => {
        console.log(e)
      })
    },
    getDict(dicts) {
      new QueryInfoService().getDictMap().then(({data}) => {
        dicts.map(([dictType, formField]) => {
          this.$set(this.inputForm, `${formField}Label`, data[dictType].find(item => item.value == this.inputForm[formField]).label);
        });
      }).catch(e => {
        console.log(e)
      })
    },
    async updateDictNames(dataList, dictTypeList) {
      const {data} = await new QueryInfoService().getDictMap();
      const promises = dataList.map(async (item) => {
        for (const [dictType, formField] of Object.entries(dictTypeList)) {
          if (data[dictType] && Array.isArray(data[dictType])) {
            const dictItem = data[dictType].find(d => d.value === item[formField]);
            if (dictItem) {
              this.$set(item, `${formField}Label`, dictItem.label);
            }
          }
        }
      });
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/its/sales/itsSalesInner/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
          }
          _this.$flow.startFlow(form, '/its/sales/itsSalesInner/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatter(value) {
      return Number(value).toFixed(2)
    },
    formatter2(value) {
      return Number(value).toFixed(4)
    },
    viewDetail() {
      if(this.inputForm.type === '1') {
        this.$router.push({
          path: '/ItsSalesInnerDepartDetail',
          query: {
            data: JSON.stringify(this.inputForm.sends),
          }
        })
      } else {
        this.$router.push({
          path: '/ItsSalesInnerSpendDepartDetail',
          query: {
            data: JSON.stringify(this.inputForm.sends),
          }
        })
      }
    },
    viewDetail2() {
      this.$router.push({
        path: '/ItsSalesInnerSalesDetail',
        query: {
          data: JSON.stringify(this.inputForm.details),
        }
      })
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    // 合计计算
    sumNum(arr, key, n = 2) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(n, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>

</style>
